import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";

import SurveyAdminContext from "../../../context/Admin/SurveyAdminContext/SurveyAdminContext";
import SurveyAdmin from "../SurveyAdmin/SurveyAdmin";
import UserSatisfactionAdminContext from "../../../context/Admin/UserSatisfactionAdminContext/UserSatisfactionAdminContext";
import UserSatisfactionAdmin from "../UserSatisfactionAdmin/UserSatisfactionAdmin";
import ViolationTypeAdminContext from "../../../context/Admin/ViolationTypeAdminContext/ViolationTypeAdminContext";
import ViolationTypeAdmin from "../ViolationTypeAdmin/ViolationTypeAdmin";
import ViolationResultAdminContext from "../../../context/Admin/ViolationResultAdminContext/ViolationResultAdminContext";
import ViolationResultAdmin from "../ViolationResultAdmin/ViolationResultAdmin";
import ViolationCommentAdminContext from "../../../context/Admin/ViolationCommentAdminContext/ViolationCommentAdminContext";
import ViolationCommentAdmin from "../ViolationCommentAdmin/ViolationCommentAdmin";
import ViolationSolvedAdminContext from "../../../context/Admin/ViolationSolvedAdminContext/ViolationSolvedAdminContext";
import ViolationSolvedAdmin from "../ViolationSolvedAdmin/ViolationSolvedAdmin";
import FailureRequestCommentAdminContext from "../../../context/Admin/FailureRequestCommentAdminContext/FailureRequestCommentAdminContext";
import FailureRequestCommentAdmin from "../FailureRequestCommentAdmin/FailureRequestCommentAdmin";
import FailureRequestAdminContext from "../../../context/Admin/FailureRequestAdminContext/FailureRequestAdminContext";
import FailureRequestAdmin from "../FailureRequestAdmin/FailureRequestAdmin";
import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";

const ItemsAdmin = () => {
  const [tabKey, setTabKey] = useState("Survey");

  const tabs = [
    {
      title: "نظرسنجی",
      key: "Survey",
      content: (
        <SurveyAdminContext>
          <SurveyAdmin />
        </SurveyAdminContext>
      ),
    },
    {
      title: "رضایت کاربر",
      key: "UserSatisfaction",
      content: (
        <UserSatisfactionAdminContext>
          <UserSatisfactionAdmin />
        </UserSatisfactionAdminContext>
      ),
    },
    {
      title: "نوع تخلف",
      key: "ViolationType",
      content: (
        <ViolationTypeAdminContext>
          <ViolationTypeAdmin />
        </ViolationTypeAdminContext>
      ),
    },
    {
      title: "نتیجه نهایی تخلف",
      key: "ViolationResult",
      content: (
        <ViolationResultAdminContext>
          <ViolationResultAdmin />
        </ViolationResultAdminContext>
      ),
    },
    // {
    //   title: "نظرات تخلف",
    //   key: "ViolationComment",
    //   content: (
    //     <ViolationCommentAdminContext>
    //       <ViolationCommentAdmin />
    //     </ViolationCommentAdminContext>
    //   ),
    // },
    {
      title: "رسیدگی تخلف",
      key: "ViolationSolved",
      content: (
        <ViolationSolvedAdminContext>
          <ViolationSolvedAdmin />
        </ViolationSolvedAdminContext>
      ),
    },
    // {
    //   title: "نظرات درخواست ها",
    //   key: "FailureRequestComment",
    //   content: (
    //     <FailureRequestCommentAdminContext>
    //       <FailureRequestCommentAdmin />
    //     </FailureRequestCommentAdminContext>
    //   ),
    // },
    {
      title: "نوع درخواست ها",
      key: "FailureRequest",
      content: (
        <FailureRequestAdminContext>
          <FailureRequestAdmin />
        </FailureRequestAdminContext>
      ),
    },
  ];
  return (
    <>
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "آیتم ها", type: "a" },
        ]}
        title="آیتم ها"
      />

      <div className="card">
        <div className="card-body text-center">
          {tabs.map((item) => (
            <button
              key={item.key}
              onClick={() => setTabKey(item.key)}
              className={`btn btn${
                item.key !== tabKey ? "-outline" : ""
              }-primary mx-2 my-1`}
            >
              {item.title}
            </button>
          ))}
        </div>
      </div>

      {tabs.find((item) => item.key === tabKey).content}
    </>
  );
};

export default ItemsAdmin;
